import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button, Title } from 'thermia-react-container';

export const NoGuideError = () => {
  const { t } = useTranslation('troubleshoot');
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate('/troubleshoot-guides');
  };

  return (
    <div>
      <Title text={t('troubleshoot.errors.noGuide')} />
      <Button title={t('troubleshoot.general.goBack')} onClick={navigateBack} variant="contained" style={{ marginTop: '40px' }} />
    </div>
  );
};
export default NoGuideError;
